import React, { useState } from 'react'
import { getClientByEmail } from './portalApi'
import { btn, font, dark } from './portalStyles'
import { translations } from './portalI18n'
import logo from 'common/assets/ifeno_logo_blanco.png'
import fondoPortal from 'common/assets/logo_fondo_portal_vectorized.png'
import { IconButton, Tooltip } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

const PortalLogin = ({ onLogin, lang, setLang }) => {
    const t = translations[lang]
    const [email, setEmail] = useState(() => {
        try {
            return new URLSearchParams(window.location.search).get('email') || ''
        } catch { return '' }
    })
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setLoading(true)

        const emailClean = email.trim()
        const passwordClean = password.trim().toUpperCase()

        try {
            const client = await getClientByEmail(emailClean)
            if (!client) {
                setError(t.errorNoClient)
                setLoading(false)
                return
            }
            if (passwordClean !== (client.id || '').toUpperCase()) {
                setError(t.errorCredentials)
                setLoading(false)
                return
            }
            onLogin(client)
        } catch {
            setError(t.errorCredentials)
            setLoading(false)
        }
    }

    const inputStyle = {
        width: '100%', boxSizing: 'border-box',
        padding: '10px 12px', borderRadius: '6px',
        border: `1.5px solid ${dark.border}`,
        fontSize: '16px', fontFamily: font, outline: 'none',
        transition: 'border-color 0.15s',
        background: dark.surface2,
        color: dark.text,
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: `${dark.bg} url(${fondoPortal}) center/cover no-repeat`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: font,
            padding: '20px',
        }}>
            <div style={{
                background: dark.surface,
                borderRadius: '12px',
                border: `1px solid ${dark.border}`,
                padding: '48px 40px',
                width: '100%',
                maxWidth: '400px',
                position: 'relative',
            }}>
                {/* Lang toggle */}
                <Tooltip title={t.switchLang} placement="bottom">
                    <button
                        onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
                        style={{
                            position: 'absolute', top: 16, right: 16,
                            background: 'transparent', border: `1px solid ${dark.border}`,
                            borderRadius: 6, padding: '2px 8px',
                            color: dark.text2, fontSize: 11, fontWeight: 700,
                            cursor: 'pointer', fontFamily: font,
                        }}
                    >
                        {lang === 'es' ? 'EN' : 'ES'}
                    </button>
                </Tooltip>

                <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                    <div style={{ marginBottom: '20px' }}>
                        <img src={logo} alt="logo" style={{ height: 36, maxWidth: 160, objectFit: 'contain', display: 'block', margin: '0 auto' }} />
                    </div>
                    <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700', color: dark.text }}>
                        {t.portalTitle}
                    </h1>
                    <p style={{ margin: '8px 0 0', color: dark.text2, fontSize: '14px' }}>
                        {t.portalSubtitle}
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: dark.text2, marginBottom: '6px' }}>
                            {t.emailLabel}
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value.toLowerCase().replace(/\s/g, ''))}
                            placeholder={t.emailPlaceholder}
                            required
                            style={inputStyle}
                            onFocus={e => e.target.style.borderColor = '#666'}
                            onBlur={e => e.target.style.borderColor = dark.border}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: dark.text2, marginBottom: '6px' }}>
                            {t.passwordLabel}
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={e => setPassword(e.target.value.toUpperCase().replace(/\s/g, ''))}
                                placeholder="••••••••"
                                required
                                style={{ ...inputStyle, padding: '10px 40px 10px 12px' }}
                                onFocus={e => e.target.style.borderColor = '#666'}
                                onBlur={e => e.target.style.borderColor = dark.border}
                            />
                            <IconButton
                                size="small"
                                onClick={() => setShowPassword(v => !v)}
                                style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', color: dark.text2 }}
                            >
                                {showPassword ? <VisibilityOffIcon style={{ fontSize: 18 }} /> : <VisibilityIcon style={{ fontSize: 18 }} />}
                            </IconButton>
                        </div>
                    </div>

                    {error && (
                        <p style={{ color: '#e05555', fontSize: '13px', margin: '0 0 16px', textAlign: 'center' }}>
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{ ...btn.primary, width: '100%', padding: '12px', fontSize: '15px', opacity: loading ? 0.6 : 1 }}
                    >
                        {loading ? t.signingIn : t.signIn}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default PortalLogin
